module.exports = __webpack_public_path__ + "img/abm.12c880a2.png";